<ng-container *ngIf="date$ | async as date">
  <app-header-nav>
    Mein Tag:
    {{ date | date: "dd.MM.YYYY" }}
    <ion-badge
      *ngIf="dateIsYesterday$ | async"
      class="ml-10"
      style="display: inline-block"
    >
      gestern
    </ion-badge>
  </app-header-nav>

  <ion-content>
    <ion-row>
      <ion-col size="3" sizeXl="2">
        <ng-container *ngIf="!focusModeEnabled">
          <div class="day-index ion-padding">
            <app-day-index-block
              *ngFor="let indexBlock of dayService.index$ | async"
              [indexBlock]="indexBlock"
              [focusedTopicId]="focusedTopicId"
              (topicClick)="scrollToAndFocusTopic($event)"
              (topicReorder)="updateTopics($event)"
            >
            </app-day-index-block>
          </div>
        </ng-container>
      </ion-col>

      <ion-col size="6" sizeXl="8">
        <div class="container">
          <ng-container *ngIf="dayService.trackerVms$ | async as trackerVms">
            <ng-container *ngIf="trackerVms.length > 0">
              <h2 class="ion-text-center">
                <ion-icon name="bar-chart-outline"></ion-icon>
                Tracker
              </h2>
              <app-entry-editor
                *ngFor="
                  let vm of trackerVms;
                  trackBy: trackByTopicAndEntryMaybe
                "
                [entry]="vm.entry"
                [topic]="vm.topic"
                [date]="date"
                [isFocused]="vm.topic.id === focusedTopicId"
                (editorFocused)="onEditorFocused($event)"
              >
              </app-entry-editor>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="dayService.pinnedVms$ | async as pinnedEntries">
            <ng-container *ngIf="pinnedEntries.length">
              <h2 class="ion-text-center">
                <ion-icon name="bookmark-outline"></ion-icon>
                Lesezeichen
              </h2>
              <app-entry-editor
                *ngFor="
                  let vm of pinnedEntries;
                  trackBy: trackByTopicAndEntryMaybe
                "
                [entry]="vm.entry"
                [topic]="vm.topic"
                [date]="date"
                [isFocused]="vm.topic.id === focusedTopicId"
                (editorFocused)="onEditorFocused($event)"
              >
              </app-entry-editor>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="dayService.otherVms$ | async as otherEntries">
            <ng-container *ngIf="otherEntries.length">
              <h2 class="ion-text-center">
                <ion-icon name="bulb-outline"></ion-icon>
                Sonstige
              </h2>
              <app-entry-editor
                *ngFor="
                  let vm of otherEntries;
                  trackBy: trackByTopicAndEntryMaybe
                "
                [entry]="vm.entry"
                [topic]="vm.topic"
                [date]="date"
                [isFocused]="vm.topic.id === focusedTopicId"
                (editorFocused)="onEditorFocused($event)"
              >
              </app-entry-editor>
            </ng-container>
          </ng-container>
        </div>
      </ion-col>

      <ion-col
        size="3"
        sizeXl="2"
        style="display: flex; justify-content: flex-end"
      >
        <ng-container *ngIf="!focusModeEnabled">
          <div
            class="ion-padding day-index"
            style="height: calc(100dvh - 66px); overflow-y: auto"
          >
            <!-- <p>Thema hinzufügen</p> -->

            <app-add-topic
              (addTopic)="createNewTopicAndAddTempTopic($event)"
            ></app-add-topic>

            <div class="ion-margin-top" style="overflow-y: auto">
              <ng-container
                *ngFor="let topic of dayService.suggestedTopics$ | async"
              >
                <div *ngIf="!topic.hidden">
                  <app-styled-topic
                    class="topic-button topic-outline mb-10 mr-10"
                    [topic]="topic"
                    (click)="addTempTopic(topic.id)"
                  >
                  </app-styled-topic>
                </div>
              </ng-container>
            </div>

            <!--        <h2>Moodtracking</h2>-->
            <!--        <ion-row>-->
            <!--          <ion-col size="12"-->
            <!--                   *ngFor="let entry of trackerEntries$ | async; trackBy: trackEntries">-->
            <!--            <ion-row>-->
            <!--              <ion-col size="auto">-->
            <!--                <ion-button fill="outline" style="width: 90px;"-->
            <!--                            (click)="changeToFullEntry(entry)">-->
            <!--                  {{entry.topic.name}}-->
            <!--                </ion-button>-->
            <!--              </ion-col>-->
            <!--              <ion-col>-->
            <!--                <ion-range class="ion-no-padding"-->
            <!--                           [value]="entry.value"-->
            <!--                           step="0.05"-->
            <!--                           [snaps]="true"-->
            <!--                           min="0"-->
            <!--                           max="1"-->
            <!--                           [pin]="true"-->
            <!--                           [pinFormatter]="pinFormatter"-->
            <!--                           [color]="entry | rangeTrackerColor"-->
            <!--                           (ionInput)="plop()"-->
            <!--                           (ionChange)="editValueByEvent($event, entry)">-->
            <!--                </ion-range>-->
            <!--              </ion-col>-->
            <!--            </ion-row>-->
            <!--          </ion-col>-->
            <!--        </ion-row>-->
          </div>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-content>
</ng-container>
